var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$store.getters.isLogged)?_c('MenuLogged'):_c('MenuWithoutLogin')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }